import { apiClient } from '../../api/client';
import { ApiResponse } from '../../api/types';
import { VIPConfig, VIPConfigInput } from './types';

export async function listVIPConfigs(): Promise<VIPConfig[]> {
  const response = await apiClient.get<ApiResponse<VIPConfig[]>>('/api/v1/admin/vip/configs');
  return response.data.data;
}

export async function updateVIPConfig(level: number, input: VIPConfigInput): Promise<VIPConfig> {
  const response = await apiClient.put<ApiResponse<VIPConfig>>(`/api/v1/admin/vip/configs/${level}`, input);
  return response.data.data;
}
